import { BRAND } from "../risikoanalyseStep/tokens";

/**
 * Ein Symbol je Gefahr (bzw. je Gefahren-Gruppe). Wird in der Gefahren-Tabelle
 * vor der Bezeichnung gezeigt.
 */
export const GefahrIcon = ({
  id,
  color,
  size = 22,
}: {
  id: string;
  color: string;
  size?: number;
}) => {
  const c = color;
  if (id === "feuer")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        {/* Outer flame */}
        <path
          d="M12 2.5c.7 2.4 2.6 3.7 3.9 5.6 1.4 2 2.1 4 2.1 6 0 3.4-2.6 6.4-6 6.4S6 17.5 6 14.1c0-1.6.6-3 1.6-4.2.5 1.4 1.4 2 1.4 2 .1-1.3.5-2.5 1.3-3.6 1-1.4 1.6-3.1 1.7-5.8z"
          fill={c}
        />
        {/* Inner flame (lighter feel via opacity) */}
        <path
          d="M12 9.2c.4 1.2 1.6 2 2.3 3.2.6 1 .9 2.1.9 3.1 0 1.9-1.4 3.5-3.2 3.5s-3.2-1.6-3.2-3.5c0-.8.3-1.6.8-2.3.3.7.8 1.1.8 1.1.1-.9.5-1.7 1.1-2.4.3-.6.5-1.2.5-2.7z"
          fill={BRAND.white}
          opacity="0.35"
        />
      </svg>
    );
  if (id === "leitungswasser")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        {/* Faucet + drop */}
        <path d="M4 6h7v3H4z" fill={c} />
        <path d="M11 7h6c1.5 0 2.5 1 2.5 2.5V11h-2V9.5c0-.3-.2-.5-.5-.5H11z" fill={c} />
        <path d="M7.5 9v3h3V9z" fill={c} opacity="0.7" />
        <path d="M9 14c1.4 1.8 2 3 2 4a2 2 0 0 1-4 0c0-1 .6-2.2 2-4z" fill={c} />
      </svg>
    );
  if (id === "sturm_hagel")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        {/* Cloud */}
        <path d="M6 13a4 4 0 0 1 0-8 5 5 0 0 1 9-1 4 4 0 0 1 1 8H6z" fill={c} />
        {/* Wind streaks */}
        <path d="M3 16h10M6 19h12M9 22h7" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    );
  if (id.startsWith("we"))
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M2 18l5-6 4 4 4-5 7 7H2z" fill={c} />
        <path d="M2 21c2-2 4-2 6 0s4 2 6 0 4-2 6 0" stroke={c} strokeWidth="1.5" fill="none" strokeLinecap="round" />
      </svg>
    );
  if (id.startsWith("ibs"))
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" fill={c} />
        <path d="M9 12l2 2 4-4" stroke={BRAND.white} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    );
  if (id === "fr")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M3 16l1.5-5h15L21 16v3h-2a2 2 0 1 1-4 0H9a2 2 0 1 1-4 0H3v-3z" fill={c} />
      </svg>
    );
  if (id === "ug")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke={c} strokeWidth="1.6" fill="none" />
        <path d="M9 9c.5-2 4-2.5 5-1 1.5 2-1.5 3-2 4v2" stroke={c} strokeWidth="1.6" strokeLinecap="round" fill="none" />
        <circle cx="12" cy="17" r="1.2" fill={c} />
      </svg>
    );
  if (id === "wug")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="10" cy="12" r="8" stroke={c} strokeWidth="1.5" fill="none" />
        <circle cx="16" cy="12" r="8" stroke={c} strokeWidth="1.5" fill="none" />
      </svg>
    );
  if (id.includes("glas"))
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="4" y="4" width="16" height="16" stroke={c} strokeWidth="1.6" fill="none" />
        <path d="M4 4l16 16M20 4L4 20" stroke={c} strokeWidth="1.2" />
      </svg>
    );
  if (id === "tv")
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="4" y="6" width="16" height="11" stroke={c} strokeWidth="1.6" fill="none" />
        <path d="M9 19h6" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="12" cy="11.5" r="2" fill={c} />
      </svg>
    );
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8" stroke={c} strokeWidth="1.6" />
    </svg>
  );
};
